import { dataProps, 
        itemListProps } from './properties'

export const setTransferWorkOrderList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setTransferWorkOrderData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    } else if(payload.copy) {
        state.props.item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const addNewTransferWorkOrderItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('production_id_'+(key-1)).focus()
    }, 300);

}

export const removeTransferWorkOrderItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setLoadReadyItemsForTransfer = (state, payload) => {

    if(payload !== undefined) {
        state.props.item_list = []
        let key = 0
        payload.forEach(element => {
            state.props.item_list.push({
                key: key,
                id: 0,
                selected: false,
                production_id: element.id,
                item_detail: {
                    work_order_number: element.work_order_number,
                    customer_name: element.customer_name,
                    sub_template_name: element.sub_template_name,
                    template_name: element.template_name,
                    process_name: element.process_name,
                    work_order_process_id: element.work_order_process_id,
                    sale_item_id: element.sale_item_id,
                    trial_name: element.trial_name != null ? element.trial_name : '',
                    promise_type: element.appointment_type,
                    appointment_date: element.appointment_date,
                    fabric_id: element.fabric_id,
                    sku_code: element.sku_code,
                    article_name: element.article_name
                }
            })
            key ++
        })
    }

}

export const setTransferWorkOrderList_ItemList = (state, payload) => {
    let itemIndex = state.list.findIndex(t => t.id === payload.id)

    if(itemIndex >=0) {
        state.list[itemIndex].item_list = payload.item_list
    }
}

export const resetTransferWorkOrderData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/transferWorkOrder/mutations.js